// AUTH-04 Verify your email, from the emailed link (?token=).
import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { api, call } from "../../api/client";
import { describeError } from "../../api/errors";
import { Banner } from "../../components/Banner";
import { Loading } from "../../components/States";
import { AuthLayout } from "./AuthLayout";
import { takeTokenFromUrl } from "./fields";

export function VerifyEmail() {
  const [token] = useState(takeTokenFromUrl);
  const [state, setState] = useState<"working" | "done" | { error: string }>(token ? "working" : { error: "This page needs the link from your email." });

  useEffect(() => {
    if (!token) return;
    call(api.POST("/auth/email/verify", { body: { token } }))
      .then(() => setState("done"))
      .catch((err) => setState({ error: describeError(err) }));
  }, [token]);

  return (
    <AuthLayout title="Verify your email" footer={<Link to="/">Continue to Substratal</Link>}>
      {state === "working" && <Loading label="Verifying" />}
      {state === "done" && <Banner>Your email is verified.</Banner>}
      {typeof state === "object" && <Banner tone="warning">{state.error}</Banner>}
    </AuthLayout>
  );
}
